/*-----------------------------------------------------------------------------/
/ Pick Up sepcific JS
/ copyright 2019 TerraCycle - All Rights Reserved
/-----------------------------------------------------------------------------*/

function getZipFromUrl() {
  const url = window.location.href.split('/');
  const cleaner = url[url.length - 1].split('#')[0];
  return xssEscape(cleaner.split('?')[0]);
}

/*-----------------------------------------------------------------------------/
/ Modal popups
/-----------------------------------------------------------------------------*/

/*-----------------------------------------------------------------------------/
/ checking if our service is avaliable to customer by his zip code
/-----------------------------------------------------------------------------*/
function validateZip(zip) {
  if (zipValidationOn) {
    const serviceAreaZipCodes = serviceAreas.split(" ");

    if (typeof gtag !== "undefined") {
      gtag("event", "zip_validation", {
        zip: zip
      });
    }
    const normalizedZip = normalizeZip(zip);
    return serviceAreaZipCodes.includes(normalizedZip);
  } else {
    return;
  }
}
function checkIfZipOnHold(zip) {
  const normalizedZip = normalizeZip(zip);
  const isOnHold = zipsOnHold.indexOf(normalizedZip) !== -1;
  if (typeof gtag !== "undefined") {
    gtag("event", "zip_validation_isonhold", {
      zip: zip,
      isOnHold: isOnHold
    });
  }
  return isOnHold;
}
function normalizeZip(zip) {
  return zip.replace('-', '');
}
function checkIfZipRedirect(zip) {
  const isRedirect = redirectZips.filter(z => z.zips.indexOf(zip) !== -1);
  if (typeof gtag !== "undefined") {
    gtag("event", "zip_validation_isredirect", {
      zip: zip,
      redirect: isRedirect.title
    });
  }
  return isRedirect && isRedirect.length > 0 ? isRedirect[0] : false;
}
function checkZIP() {
  // const serviceAreaZipCodes = ['19019','19101','19102','19102','19102','19103','19103','19103','19104','19105','19106','19107','19108','19109','19110','19111','19112','19114','19115','19116','19118','19119','19120','19121','19122','19123','19124','19125','19126','19127','19127','19128','19129','19130','19131','19132','19133','19134','19135','19136','19137','19138','19139','19140','19141','19142','19143','19144','19145','19146','19147','19148','19149','19150','19151','19151','19152','19153','19154','19155','19160','18039','18077','18081','18901','18901','18910','18911','18912','18913','18914','18916','18917','18920','18921','18922','18923','18925','18926','18927','18928','18929','18930','18931','18932','18933','18933','18934','18935','18938','18940','18940','18940','18942','18943','18944','18946','18947','18949','18950','18951','18953','18954','18954','18955','18956','18960','18962','18963','18966','18966','18966','18968','18970','18972','18974','18976','18977','18977','18980','18981','19007','19007','19007','19007','19020','19020','19020','19020','19021','19021','19030','19047','19047','19047','19047','19053','19053','19053','19053','19053','19054','19054','19055','19056','19056','19057','19058','19059','19067','19067','18041','18054','18070','18073','18073','18074','18076','18084','18915','18918','18924','18936','18957','18958','18964','18969','18971','18979','19001','19001','19001','19002','19002','19002','19003','19004','19004','19006','19009','19012','19025','19027','19027','19027','19027','19031','19034','19035','19038','19038','19038','19038','19040','19041','19044','19046','19046','19046','19046','19046','19046','19066','19072','19075','19090','19095','19096','19401','19403','19403','19403','19403','19404','19405','19405','19406','19406','19407','19407','19408','19408','19409','19409','19420','19422','19422','19422','19423','19426','19428','19428','19430','19435','19436','19436','19437','19438','19440','19443','19444','19446','19450','19451','19452','19453','19453','19454','19456','19462','19464','19464','19464','19468','19468','19468','19472','19473','19473','19474','19477','19477','19478','19484','19485','19486','19490','19492','19492','19505','19525','19008','19010','19013','19013','19013','19014','19014','19015','19015','19016','19017','19018','19018','19018','19018','19018','19022','19022','19022','19023','19023','19026','19026','19028','19029','19029','19032','19033','19036','19037','19037','19037','19039','19043','19050','19050','19050','19052','19061','19061','19061','19061','19061','19063','19063','19063','19063','19063','19064','19065','19065','19070','19073','19074','19076','19078','19079','19081','19082','19083','19083','19085','19086','19086','19087','19087','19087','19087','19087','19094','19113','19317','19319','19331','19342','19373','08690','08520','08525','08619','08534','08540','08542','08550','08560','08608','08609','08610','08611','08618','08628','08629','08638','08648','08691','08561','08620','08010','08010','08016','08016','08016','08022','08036','08036','08046','08052','08054','08057','08060','08060','08060','08060','08065','08073','08075','08075','08075','08076','08077','08077','08505','08518','08554','08002','08003','08007','08018','08029','08030','08030','08031','08033','08034','08035','08045','08049','08059','08078','08083','08083','08084','08099','08101','08102','08103','08104','08105','08106','08107','08107','08108','08108','08109','08109','08110','08110'];
  if (zipValidationOn) {
    const zip = xssEscape($('#zip-code').val());

    if (zip != "") {
      if (validateZip(zip)) {
        $('#checkout').trigger('click');
      } else {
        showModal('zip-not-ok');
      }
    } else {
      showModal('no-zip');
    }
  }
}

function goToPricing(zip) {
  let newLocation = "/pages/pricing/" + zip;
  window.location.href = newLocation;
};

function checkZIPNotInCart(event) {
  if (zipValidationOn) {
    let zip = xssEscape($('#zip-code').val());
    let subscr = false;
    if (!zip) {
      zip = $('#your-zip-code').val();
      subscr = true;
    }

    if (zip != "") {
      handleZip(zip, subscr);
    } else {
      showPopup('zip-missing-pop');
      //showModal('no-zip');
    }
  }
}


function checkZIPInPop() {
  if (zipValidationOn) {
    const zip = xssEscape($('#zip-code-pop').val());
    if (zip != "") {
      handleZip(zip);
    }
  }
}

function handleZip(zip, subscr) {
  if (zipValidationOn) {
    if (validateZip(zip)) {
      if (subscr) {
        event.preventDefault();
      }
      hideZipInputPopUp();
      localStorage.setItem('zip', zip);

      const redirEl = document.getElementById("redirectTo");
      if (redirEl && redirEl.value !== "") {
        goTo(redirEl.value);
      } else {
        goToPricing(zip);
      }
    } else if (checkIfZipOnHold(zip)) {
      showOnHoldZipText();
      showWrongZipPopUp(zip, true, "waitlist,wl1,onHoldZip");
    } else if (redirectTo = checkIfZipRedirect(zip)) {
      hideZipInputPopUp();
      showPopup(redirectTo.popup_id);
    } else {
      hideOnHoldZipText();
      showWrongZipPopUp(zip);
    }
  } else {
    const redirEl = document.getElementById("redirectTo");
    if (redirEl && redirEl.value !== "") {
      goTo(redirEl.value);
    } else {
      goToPricing();
    }
  }
}


function goTo(target) {
  if (target[0] === "/") {
    window.location.href = target;
  }
}
function goToCart() {
  window.location.href = "/cart";
}

function showOnHoldZipText() {
  let zipWrongText = document.getElementById("wrong-zip-pop-text");
  if (zipWrongText) {
    zipWrongText.style.display = "none";
  }
  let zipOnHoldText = document.getElementById("zip-onhold-pop-text");
  if (zipOnHoldText) {
    zipOnHoldText.style.display = "block";
  }
}
function hideOnHoldZipText() {
  let zipWrongText = document.getElementById("wrong-zip-pop-text");
  if (zipWrongText) {
    zipWrongText.style.display = "block";
  }
  let zipOnHoldText = document.getElementById("zip-onhold-pop-text");
  if (zipOnHoldText) {
    zipOnHoldText.style.display = "none";
  }
}

function findZipZone(zip) {
  let zipTag = "";
  if (zip && zipZones) {
    const zipZone = zipZones.find(zz => zz.zips.indexOf(zip) !== -1);
    if (zipZone) {
      zipTag = zipZone.tag;
    } else {
      console.info("Outside Zones:", zip);
    }
  } else {
    console.warn("zipZones not defined");
  }
  return zipTag;
}

function showWrongZipPopUp(zip, hideTryAgain, newTagList) {
  hideZipInputPopUp();
  showPopup("zip-wrong-pop");

  const zipWrongPopup = document.getElementById("zip-wrong-pop");

  let zipInput = zipWrongPopup.querySelector('input[name="contact[note][zip]"]');
  if (zipInput) {
    zipInput.value = zip;
  }

  let zipNum = zipWrongPopup.querySelector(".your-zip__num");
  if (zipNum) {
    zipNum.innerHTML = zip;
  }
  if (newTagList) {
    const tagList = zipWrongPopup.querySelector('input[name="contact[tags]"]');
    if (tagList) {
      tagList.value = newTagList;
    }
  }
  const zoneTag = findZipZone(zip);
  const tagList = zipWrongPopup.querySelector('input[name="contact[tags]"]');
  if (tagList) {
    tagList.value = tagList.value + "," + zip + (zoneTag ? ',' + zoneTag : "");
    console.log("zipTag:", tagList.value);
  }
}

function hideWrongZipPopUp() {

  let zipWrongPopup = document.getElementById("zip-wrong-pop");
  if (zipWrongPopup) {
    zipWrongPopup.style.display = "none";
  }

}

function showZipInputPopUp(redirectTo) {
  if (zipValidationOn) {
    if (redirectTo) {
      const redirEl = document.getElementById("redirectTo");
      if (redirEl) {
        redirEl.value = redirectTo;
      }
    }
    const zipPopup = document.getElementById("zip-check-pop");
    if (zipPopup) {
      zipPopup.style.display = "block";
      if (typeof gtag !== "undefined") {
        gtag("event", "show_zip_check_popup");
      }
    }
  } else {
    if (redirectTo) {
      goTo(redirectTo);
    } else {
      goToPricing();
    }
  }
}


function hideZipInputPopUp() {
  let zipPopup = document.getElementById("zip-check-pop");
  if (zipPopup) {
    zipPopup.style.display = "none";
  }
}

function showPopup(id) {
  let popup = document.getElementById(id);
  if (popup) {
    popup.style.display = "block";
  }
}
function hidePopup(id) {
  let popup = document.getElementById(id);
  if (popup) {
    popup.style.display = "none";
  }
}

function tryInputZipAgain() {
  hideWrongZipPopUp();
  showZipInputPopUp();
}

function getUrlVars() {
  let vars = [], hash;
  let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (let i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}

function validateEmail(email) {
  return email.match(
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
  );
}

function validateWLS(emailId) {
  console.log("validateWLS");
  const email = document.getElementById(emailId).value;
  const isValid = validateEmail(email);
  if (!isValid) {
    document.getElementById(emailId + '-error').style.display = "block";
  }

  if (typeof gtag !== "undefined" && isValid) {
    gtag("event", "waitlist_subscription");
  }
  return isValid;
}






